import { Typography, TypographyProps } from '@mui/material';
import { CSSObject, styled } from '@mui/system';

interface AccordionTitleProps extends TypographyProps {
  isEditMode?: boolean;
}

export const AccordionTitle = styled(Typography, {
  shouldForwardProp: (props) => {
    if (props === 'isEditMode') {
      return false;
    }

    return true;
  },
})<AccordionTitleProps>((props) => {
  const style: CSSObject = {
    fontWeight: 400,
  };

  if (props.isEditMode) {
    style.fontWeight = 700;
  }

  return style;
});
